import { FormattedMessage } from 'react-intl';

export const STOPPED_JOB_STATUS_ID = -3;
export const SYSTEM_STUDY_ID = 1;
/*
5	Submitted (Above Normal Priority)
3	Submitted (Below Normal Priority)
6	Submitted (High Priority)
2	Submitted (Low Priority)
4	Submitted (Normal Priority)
7	Submitted (Uber Priority)
20	Queued In Batch Compute
*/
const SUBMITTED_LOW_JOB_STATUS_ID = 2;
const SUBMITTED_BELOW_STATUS_ID = 3;
const SUBMITTED_NORMAL_JOB_STATUS_ID = 4;
const SUBMITTED_ABOVE_JOB_STATUS_ID = 5;
const SUBMITTED_HIGH_JOB_STATUS_ID = 6;
const SUBMITTED_UBER_JOB_STATUS_ID = 7;
const QUEUED_IN_BATCH_COMPUTE_JOB_STATUS_ID = 20;

// Dynamic Property Codes
export const OTHERPARAMETERS_CODE = 'OTHERPARAMS';

// Fast Mode / Deterministic Mitigation Sensitivities and Run Mode
export const RT_PRICE_SENSITIVITY = {
    FAST_MODE: { description: 'rt price fast mode' },
    DETERMINISTIC_MITIGATION: { description: 'rt price deterministic mitigation' },
};
export const RUN_RT_PRICE_MODE_MAP = {
    fastMode: 'RunRTPriceSimFastMode=1\nRunRTDeterministicMode=0',
    stochasticSubHourly: 'RunRTPriceSimFastMode=0\nRunRTDeterministicMode=1',
};

export const submittedJobStatusIds = [
    SUBMITTED_LOW_JOB_STATUS_ID,
    SUBMITTED_BELOW_STATUS_ID,
    SUBMITTED_NORMAL_JOB_STATUS_ID,
    SUBMITTED_ABOVE_JOB_STATUS_ID,
    SUBMITTED_HIGH_JOB_STATUS_ID,
    SUBMITTED_UBER_JOB_STATUS_ID,
    QUEUED_IN_BATCH_COMPUTE_JOB_STATUS_ID,
];

export const initialJobsVisibleColunms = [
    'status',
    'jobId',
    'moduleId',
    'studyId',
    'studyName',
    'bookName',
    'sensitivityId',
    'processedBy',
    'scheduledRunTime',
    'attempt',
    'startDate',
    'endDate',
    'runTimeHours',
    'jobType',
    'portfolio',
    'submittedBy',
    'runTimeMinutes',
    'debug',
];

// initialJobsVisibleColunms array and jobsColumnSelectionOptions array must have the same number and names/ids of columns
export const jobsColumnSelectionOptions = [
    {
        id: 'status',
        disabled: false,
        label: <FormattedMessage id="jobs_table_status" />,
    },
    {
        id: 'jobId',
        disabled: false,
        label: <FormattedMessage id="jobs_table_job_id" />,
    },
    {
        id: 'moduleId',
        disabled: false,
        label: <FormattedMessage id="jobs_table_module" />,
    },
    {
        id: 'studyId',
        disabled: false,
        label: <FormattedMessage id="jobs_table_study_id" />,
    },
    {
        id: 'studyName',
        disabled: false,
        label: <FormattedMessage id="jobs_table_study_name" />,
    },
    {
        id: 'bookName',
        disabled: false,
        label: <FormattedMessage id="jobs_table_book" />,
    },
    {
        id: 'sensitivityId',
        disabled: false,
        label: <FormattedMessage id="jobs_table_sensitivity" />,
    },
    {
        id: 'processedBy',
        disabled: false,
        label: <FormattedMessage id="jobs_table_processed_by" />,
    },
    {
        id: 'scheduledRunTime',
        disabled: false,
        label: <FormattedMessage id="jobs_table_scheduled_runtime" />,
    },
    {
        id: 'attempt',
        disabled: false,
        label: <FormattedMessage id="jobs_table_attempt" />,
    },
    {
        id: 'startDate',
        disabled: false,
        label: <FormattedMessage id="jobs_table_start_date" />,
    },
    {
        id: 'endDate',
        disabled: false,
        label: <FormattedMessage id="jobs_table_end_date" />,
    },
    {
        id: 'runTimeHours',
        disabled: false,
        label: <FormattedMessage id="jobs_table_run_time" />,
    },
    {
        id: 'jobType',
        disabled: false,
        label: <FormattedMessage id="jobs_table_job_type" />,
    },
    {
        id: 'portfolio',
        disabled: false,
        label: <FormattedMessage id="jobs_table_job_portfolio" />,
    },
    {
        id: 'submittedBy',
        disabled: false,
        label: <FormattedMessage id="jobs_table_job_submitted_by" />,
    },
    {
        id: 'runTimeMinutes',
        disabled: false,
        label: <FormattedMessage id="jobs_table_job_run_time_min" />,
    },
    {
        id: 'debug',
        disabled: false,
        label: <FormattedMessage id="jobs_table_debug" />,
    },
];
